import {
  createSlice,
  createEntityAdapter,
  createSelector
} from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'
import { api, providesList } from '../base'
import socket from '../../socket'

const transformErrorResponse = (response, meta, arg) => response.error

const messagesAdapter = createEntityAdapter({
  selectId: (message) => message.id,
  sortComparer: (a, b) => a.created_at < b.created_at ? -1 : 1
})
const initialState = messagesAdapter.getInitialState()

export const messagesApi = api
  .enhanceEndpoints({ addTagTypes: ['Message'] })
  .injectEndpoints({
    keepUnusedDataFor: 60 * 15, // 15 minutes
    endpoints: (builder) => ({
      // list messages for room_id
      listMessages: builder.query({
        query: (room_id) => ({
          url: '/api/messages',
          method: 'GET',
          params: { room_id },
        }),
        transformResponse: (response, meta, arg) => {
          //console.log('[listMessages.transformResponse]')
          return messagesAdapter.upsertMany(
            initialState,
            response.messages.items)
        },
        transformErrorResponse,
        providesTags: (result, error, room_id) => [{ type: 'Message', id: room_id }],
        async onQueryStarted(
          room_id,
          queryLifecycleAPI
        ) {
          //console.log('[listMessages.onQueryStarted]', queryLifecycleAPI.getState().api.queries[`listMessages("${room_id}")`].status)
          try {
            await queryLifecycleAPI.queryFulfilled
            //console.log('[listMessages.onQueryStarted] queryFulfilled:', queryLifecycleAPI.getState().api.queries[`listMessages("${room_id}")`].status)
          } catch {
            console.error('Some error')
          }
          socket.emit('join', { room_id })
        },
        async onCacheEntryAdded(
          room_id,
          queryCacheLifecycleAPI
        ) {
          //console.log('[listMessages.onCacheEntryAdded]')
          try {
            await queryCacheLifecycleAPI.cacheDataLoaded
            const listener = (data) => {
              //console.log(`[message:${room_id}] data =`, data)
              queryCacheLifecycleAPI.updateCachedData((draft) => {
                return messagesAdapter.upsertOne(draft, data)
              })
            }
            const correction_listener = (data) => {
              queryCacheLifecycleAPI.updateCachedData((draft) => {
                messagesAdapter.updateOne(draft, {
                  id: data.message_id,
                  changes: {
                    correction: data
                  }
                })
              })
            }
            socket.on(`message:${room_id}`, listener)
            socket.on('correction', correction_listener)
          } catch (err) {
            console.error(err)
          }

          await queryCacheLifecycleAPI.cacheEntryRemoved
          //console.log(`[cacheEntryRemoved listMessages(${room_id})`)
          socket.off(`message:${room_id}`)
          socket.off('correction')
        },
      }),
      // send a message to a room
      sendMessage: builder.mutation({
        queryFn: (message) => {
          //console.log('sending:', message)
          return new Promise(resolve => {
            socket.emit('message', message, () => {
              //console.log('resolving')
              resolve({ data: message })
            })
          })
        },
        async onQueryStarted(
          message,
          { dispatch, queryFulfilled }
        ) {
          //console.log('[sendMessage.onQueryStarted]', message)
          const sendResult = dispatch(
            api.util.updateQueryData('listMessages', message.room_id, (draft) => {
              return messagesAdapter.upsertOne(draft, message)
            })
          )
          try {
            await queryFulfilled
          } catch (err) {
            console.error(err)
            sendResult.undo()
          }
        },
        //
      }),
      //
    }),
  })

export const {
  useListMessagesQuery,
  useSendMessageMutation,
} = messagesApi

